/* ROTEM+ collection filtering — submits native Shopify filter params */
(function () {
  function apply(form) {
    const params = new URLSearchParams();

    document.querySelectorAll('[data-facet-form]').forEach((current) => {
      new FormData(current).forEach((value, key) => {
        if (value !== '' && value !== null) params.append(key, value);
      });
    });

    const base = window.location.pathname;
    window.location.href = params.toString() ? `${base}?${params}` : base;
    void form;
  }

  document.addEventListener('change', (event) => {
    const form = event.target.closest('[data-facet-form]');
    if (form) apply(form);
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-facet-form]');
    if (!form) return;
    event.preventDefault();
    apply(form);
  });
})();
